import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { arrowDirection, isActivateKey, isBackKey, isTextEntry } from "../lib/tv-keys";
import {
  clickTrapClose,
  focusPreferredEntry,
  getTopTrap,
  moveSpatial,
  syncFocusClass,
  syncTraps,
} from "../lib/tv-navigation";

export default function TvNavigation(): null {
  var history = useHistory();
  var location = useLocation();

  useEffect(
    function () {
      var cancelled = false;
      function tryFocus() {
        if (cancelled) return;
        if (getTopTrap()) return;
        var active = document.activeElement;
        if (
          active &&
          active !== document.body &&
          active !== document.documentElement &&
          document.body.contains(active)
        ) {
          return;
        }
        focusPreferredEntry();
      }

      var soon = window.setTimeout(tryFocus, 50);
      var later = window.setTimeout(function () {
        var active = document.activeElement;
        if (active && active !== document.body && active !== document.documentElement) return;
        tryFocus();
      }, 1200);

      return function () {
        cancelled = true;
        window.clearTimeout(soon);
        window.clearTimeout(later);
      };
    },
    [location.pathname]
  );

  useEffect(function () {
    var scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      window.setTimeout(function () {
        scheduled = false;
        syncTraps();
      }, 0);
    }

    schedule();
    var observer = new MutationObserver(schedule);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["data-tv-trap"],
    });
    return function () {
      observer.disconnect();
    };
  }, []);

  useEffect(
    function () {
      function onKeyDown(ev: KeyboardEvent) {
        if (ev.defaultPrevented) return;
        var target = ev.target;
        var el: HTMLElement | null = null;
        if (target && (target as Node).nodeType === 1) {
          el = target as HTMLElement;
        } else if (document.activeElement && document.activeElement.nodeType === 1) {
          el = document.activeElement as HTMLElement;
        }

        if (isBackKey(ev, el)) {
          var trap = getTopTrap();
          if (trap) {
            ev.preventDefault();
            clickTrapClose(trap);
            return;
          }
          ev.preventDefault();
          if (location.pathname === "/") return;
          history.goBack();
          return;
        }

        if (isActivateKey(ev)) {
          var current = document.activeElement as HTMLElement | null;
          if (current && current.nodeType === 1 && !isTextEntry(current)) {
            var tag = current.tagName;
            var canClick = tag === "BUTTON" || tag === "A" || current.getAttribute("data-tv-focus") != null;
            var targetIsControl = el === current || (el && current.contains(el));
            if (canClick && (!ev.isTrusted || !targetIsControl)) {
              ev.preventDefault();
              current.click();
              return;
            }
          }
        }

        var dir = arrowDirection(ev);
        if (!dir) return;
        if (el && isTextEntry(el) && (dir === "left" || dir === "right")) return;
        if (moveSpatial(dir)) ev.preventDefault();
      }

      function onFocusIn(ev: FocusEvent) {
        var t = ev.target;
        if (t && (t as Node).nodeType === 1) {
          syncFocusClass(t as HTMLElement);
        }
      }

      window.addEventListener("keydown", onKeyDown, false);
      document.addEventListener("focusin", onFocusIn, false);
      return function () {
        window.removeEventListener("keydown", onKeyDown, false);
        document.removeEventListener("focusin", onFocusIn, false);
      };
    },
    [history, location.pathname]
  );

  return null;
}
